/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ cost: NonNullable<unknown>, balance: NonNullable<unknown> }} Pricing_Public_Generation_NeedsInputs */

const en_pricing_public_generation_needs = /** @type {(inputs: Pricing_Public_Generation_NeedsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`This video costs ${i?.cost} credits. You have ${i?.balance}.`)
};

const es_pricing_public_generation_needs = /** @type {(inputs: Pricing_Public_Generation_NeedsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Este video cuesta ${i?.cost} créditos. Tienes ${i?.balance}.`)
};

/**
* | output |
* | --- |
* | "This video costs {cost} credits. You have {balance}." |
*
* @param {Pricing_Public_Generation_NeedsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const pricing_public_generation_needs = /** @type {((inputs: Pricing_Public_Generation_NeedsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Public_Generation_NeedsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pricing_public_generation_needs(inputs)
	return es_pricing_public_generation_needs(inputs)
});